module.exports = __webpack_public_path__ + "img/arrow.6d6a417d.svg";